import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useIsMobileDevice, Typography } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useRoadwork } from "../../hooks/queries/useRoadwork"

import { RoadworkSectionDocumentList } from "../RoadworkSectionDocumentList"
import { RoadworkSectionLength } from "../RoadworkSectionLength"
import { StatusSelector } from "../StatusSelector"

import * as Styled from "./RoadworkSectionSidebarContent.styled"

export function RoadworkSectionSidebarContent(props) {

    const { className } = props
    const isMobile = useIsMobileDevice()
    const { t } = useTranslation(I18N_NAMESPACE)
    const { road, roadworkUuid } = useParams()
    const { data: roadwork } = useRoadwork(roadworkUuid, road)

    return <Styled.Container
        className={className}
        id="sidebar-technique-content-container"
    >
        <Styled.Header>
            {roadwork?.tasks?.length ? <StatusSelector roadworkUuid={roadwork?.uuid} /> : null}
            <Styled.LocationHeader isMobile={isMobile}>
                <Typography variant="H3">{t(I18N_NAMESPACE, "containers.roadworkSectionSidebarContent.location")}</Typography>
            </Styled.LocationHeader>
            <Styled.SegmentDetailInfo
                isMobile={isMobile}
                lengthLabel={t(I18N_NAMESPACE, "components.roadworkDetail.length")}
                LengthComponent={<RoadworkSectionLength roadworkUuid={roadworkUuid} />}
                road={road}
            />
        </Styled.Header>
        <Styled.RoadworkDetailsForm />
        <RoadworkSectionDocumentList roadworkId={roadworkUuid} />
    </Styled.Container>
}